var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcarnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1094_1716)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.524536 0H14.4753C14.764 0 15 0.237793 15 0.528442V9.78064H0V0.528442C0 0.237793 0.23584 0 0.524536 0ZM1.38794 1.22961H11.4763V2.70007H1.38794V1.22961ZM10.1841 5.82605H13.6121V6.6405H10.1841V5.82605ZM7.56567 5.82605H9.48438V6.6405H7.56567V5.82605ZM7.56567 7.66064H13.6121V8.47485H7.56567V7.66064ZM7.42224 3.99182H13.6121V4.80615H7.42224V3.99182ZM1.38794 8.55115V7.71619C1.83472 7.51733 3.20251 7.1488 3.26733 6.60156C3.28174 6.47803 2.99048 5.99817 2.92383 5.77258C2.83997 5.63855 2.7948 5.59094 2.797 5.4259C2.7981 5.33289 2.79956 5.24158 2.81274 5.15222C2.82996 5.03821 2.82629 5.03442 2.88611 4.94263C2.94836 4.84717 2.92163 4.49829 2.92163 4.36682C2.92163 3.05737 5.21594 3.05713 5.21594 4.36682C5.21594 4.53235 5.17798 4.83655 5.26794 4.96667C5.31165 5.03015 5.30359 5.03748 5.31836 5.11499C5.33777 5.21631 5.33911 5.32031 5.34082 5.4259C5.34302 5.59094 5.29785 5.63855 5.21399 5.77258C5.13257 6.00977 4.82336 6.45801 4.84973 6.59229C4.948 7.0918 6.21692 7.42749 6.61646 7.6051V8.55115H1.38794ZM12.0947 1.22961H13.6121V2.70007H12.0947V1.22961Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1094_1716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 9.78064,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcarnet);
export default __webpack_public_path__ + "static/media/icarnet.c075c05ac5a3f3d473102bef5f363d5f.svg";
export { ForwardRef as ReactComponent };